<figure class="c-media">
  <div class="c-media__placeholder" role="img">
    <img [src]="component.content.imageData | file:'image':'cms':1280" [alt]="component.content.alt">
  </div>
  <figcaption *ngIf="component.content.description">{{component.content.description}}</figcaption>
</figure>
